// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"ed158449","703":"4a01edae","787":"28cb0dcd"}[chunkId] + ".chunk.js";
};